<template>
    <slot />
  </template>
  
  <script>
  export default {
    name: 'NoneLayout',
  }
  </script>